export { default } from './DestacatsHomeMarato';
